export const getUserStatistics = async (apiCall, fromDate, toDate) => {
  try {
    const resp = await apiCall(
      `/statistics/userCount`,
      "POST",
      { fromDate, toDate },
      "admin",
    );
    return resp;
  } catch (error) {
    console.error("Error fetching user statistics:", error);
    return null;
  }
};

export const getAssistantStatistics = async (apiCall, fromDate, toDate) => {
  try {
    const resp = await apiCall(
      "/assistant/statistics/get",
      "POST",
      { fromDate, toDate },
      "admin",
    );
    return resp;
  } catch (error) {
    console.error("Error fetching assistant statistics:", error);
    return null;
  }
};

export const getHistoryStatistics = async (apiCall, fromDate, toDate) => {
  try {
    const resp = await apiCall(
      "/automation/execution/statistics/get",
      "POST",
      {
        fromDate,
        toDate,
      },
      "admin",
    );
    return resp;
  } catch (error) {
    console.error("Error fetching history statistics:", error);
    return null;
  }
};

export const getAutomationStatistics = async (apiCall, fromDate, toDate) => {
  try {
    const resp = await apiCall(
      "/automation/statistics/get",
      "POST",
      {
        fromDate,
        toDate,
      },
      "admin",
    );
    return resp;
  } catch (error) {
    console.error("Error fetching automation statistics:", error);
    return null;
  }
};
